import { AbstractControl, ValidatorFn } from '@angular/forms';
import { differenceInCalendarDays } from 'date-fns';

export const calendarRangeDurationValidator = (
  durationControlName: string,
  startDateControlName: string,
  endDateControlName: string,
): ValidatorFn => {
  return (control: AbstractControl<number, number>) => {
    const durationControlValue = control.get(durationControlName)?.value;
    const startDateValue = control.get(startDateControlName)?.value;
    const endDateValue = control.get(endDateControlName)?.value;

    if (
      !startDateValue ||
      !endDateValue ||
      !durationControlValue ||
      typeof durationControlValue !== 'number'
    )
      return null;

    const datesDelta = differenceInCalendarDays(endDateValue, startDateValue);

    if (durationControlValue > datesDelta) {
      return {
        calendarDurationMismatch: {
          value: durationControlValue,
          expectedValue: datesDelta,
        },
      };
    }
    return null;
  };
};
